module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/backstage-module/components/performer-search-select/performer-search-select.component.scss
// module id = ./src/app/modules/backstage-module/components/performer-search-select/performer-search-select.component.scss
// module chunks = 9